import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Reporting Module Service Stores
 * Services for generating and managing reports
 */
export const reportingStores: ServiceStoreConfig[] = [
  {
    name: "daily-production-report",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.dailyProductionReportStore as {
            entities?: Record<string, unknown>[];
          };
          const entities = store?.entities || [];
          const totalReports = entities.length;
          const todayReports = entities.filter(
            (report) => {
              const reportDate = new Date(report.createdAt as string);
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              return reportDate >= today;
            }
          ).length;
          const weekReports = entities.filter(
            (report) => {
              const reportDate = new Date(report.createdAt as string);
              const weekAgo = new Date();
              weekAgo.setDate(weekAgo.getDate() - 7);
              return reportDate >= weekAgo;
            }
          ).length;
          const totalProduction = entities.reduce(
            (sum, report) => {
              return sum + ((report.totalProduction as number) || (report.totalVolume as number) || 0);
            },
            0
          );

          return [
            {
              title: "Total Reports",
              value: () => totalReports.toString(),
              valueColor: "primary.main",
              variant: "with-icon" as const,
            },
            {
              title: "Today",
              value: () => todayReports.toString(),
              valueColor: "info.main",
            },
            {
              title: "This Week",
              value: () => weekReports.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Total Production (cy)",
              value: () => totalProduction.toFixed(0),
              valueColor: "success.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
        defaultSort: {
          sortBy: ["reportDate"],
          sortDirection: { reportDate: "DESC" },
        },
        actions: {
          onRowClick: (row) => {
            console.log("View report:", row.reportId);
          },
        },
      },
    },
  },
  {
    name: "truck-utilization-report",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.truckUtilizationReportStore as {
            entities?: Record<string, unknown>[];
          };
          const entities = store?.entities || [];
          const totalReports = entities.length;
          const avgUtilization = entities.reduce(
            (sum, report) => {
              return sum + ((report.utilizationPercent as number) || (report.utilization as number) || 0);
            },
            0
          ) / Math.max(entities.length, 1);
          const highUtilization = entities.filter(
            (report) => {
              const util = (report.utilizationPercent as number) || (report.utilization as number) || 0;
              return util >= 80;
            }
          ).length;
          const lowUtilization = entities.filter(
            (report) => {
              const util = (report.utilizationPercent as number) || (report.utilization as number) || 0;
              return util < 50;
            }
          ).length;

          return [
            {
              title: "Total Reports",
              value: () => totalReports.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Avg Utilization",
              value: () => `${avgUtilization.toFixed(0)}%`,
              valueColor: "info.main",
            },
            {
              title: "High Util (>80%)",
              value: () => highUtilization.toString(),
              valueColor: "success.main",
            },
            {
              title: "Low Util (<50%)",
              value: () => lowUtilization.toString(),
              valueColor: "warning.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
        defaultSort: {
          sortBy: ["reportDate"],
          sortDirection: { reportDate: "DESC" },
        },
      },
    },
  },
];